const itineraries = {
  RajasthanBest: [
    {
      day: "Day 01",
      title: "Arrival at Delhi",
      content:
        "Arrival at Delhi Airport, Railway Station, or Bus Stand. Meet our representative and transfer to the hotel. After check-in and rest, visit Red Fort, Rashtrapati Bhawan, Jama Masjid, India Gate, Parliament House, Laxmi Narayan Temple, and Lotus Temple. Overnight stay at the hotel in Delhi."
    },
    {
      day: "Day 02",
      title: "Delhi – Mandawa",
      content:
        "After breakfast, drive to Mandawa (257 km). On arrival, check in to the hotel. Visit Shekhawati villages like Nawalgarh, Mandawa, and Dundlod to explore the heritage havelis. Overnight stay at the hotel."
    },
    {
      day: "Day 03",
      title: "Mandawa to Bikaner",
      content:
        "Early morning, check out and drive to Bikaner. Check in to the hotel and relax. Later, visit Junagarh Fort and Lalgarh Museum. Overnight stay at the hotel in Bikaner."
    },
    {
      day: "Day 04",
      title: "Bikaner – Jaisalmer",
      content:
        "After breakfast, drive to Jaisalmer. On arrival, check in to the hotel. In the evening, enjoy a camel safari and sunset view at Sam Sand Dunes. Overnight stay at the hotel in Jaisalmer."
    },
    {
      day: "Day 05",
      title: "Jaisalmer Sightseeing",
      content:
        "After breakfast, enjoy a full-day sightseeing tour including Jaisalmer Fort, Museum, Jain Temple, Patwon ki Haveli, Kothari Haveli. After lunch, visit Kulcihera and enjoy the desert sunset at Sam Sand Dunes again. Overnight stay at the hotel."
    },
    {
      day: "Day 06",
      title: "Jaisalmer – Jodhpur",
      content:
        "Morning drive to Jodhpur. Check in to the hotel. Visit Mehrangarh Fort, Moti Mahal, and Phool Mahal. Overnight stay at the hotel in Jodhpur."
    },
    {
      day: "Day 07",
      title: "Jodhpur – Udaipur via Ranakpur",
      content:
        "After breakfast, drive to Udaipur. En route, visit the Ranakpur Jain Temples and the nearby Sun Temple. Continue the drive to Udaipur. Check in to the hotel and overnight stay."
    },
    {
      day: "Day 08",
      title: "Udaipur Sightseeing",
      content:
        "After breakfast, explore the city of lakes: City Palace, Lake Pichola, Saheliyon ki Badi, Jag Mandir, Jagdish Temple, and enjoy fine dining lakeside in the evening. Overnight stay at the hotel in Udaipur."
    },
    {
      day: "Day 09",
      title: "Udaipur – Pushkar via Chittorgarh",
      content:
        "After breakfast, drive to Pushkar via Chittorgarh. Visit the historic Chittorgarh Fort along the way. Arrive in Pushkar and check in to the hotel. Overnight stay in Pushkar."
    },
    {
      day: "Day 10",
      title: "Pushkar – Jaipur",
      content:
        "After breakfast, visit the Brahma Temple and holy Pushkar Lake. Also visit the famous Dargah of Moinuddin Chishti (in Ajmer). Later, drive to Jaipur. Check in to the hotel. Overnight stay at the hotel in Jaipur."
    },
    {
      day: "Day 11",
      title: "Jaipur Sightseeing & Departure",
      content:
        "After breakfast, enjoy a full day sightseeing in Jaipur including Amber Fort, City Palace, Chandra Mahal, Mubarak Mahal, Hawa Mahal, and Nahargarh Fort. In the evening, drop off at the Jaipur Airport / Railway Station / Bus Stand for departure."
    }
  ],
  RajasthanWildlife: [
    {
      day: "Day 01",
      title: "Arrival in Delhi",
      content:
        "Pickup from Delhi Airport, Railway Station, or Bus Stand by our driver. Transfer to hotel for check-in. Visit Red Fort, Rashtrapati Bhawan, Jama Masjid, India Gate, Parliament House, Laxmi Narayan Temple, and Lotus Temple. Overnight stay at the hotel in Delhi."
    },
    {
      day: "Day 02",
      title: "Delhi – Sariska",
      content:
        "After breakfast, explore Chandni Chowk and Qutab Minar. Later, drive to Sariska National Park. Check in to the hotel upon arrival. Overnight stay at Sariska."
    },
    {
      day: "Day 03",
      title: "Sariska – Bharatpur",
      content:
        "After breakfast, enjoy a jungle safari at Sariska to explore the wildlife. Later, head to Bharatpur. Evening at leisure to explore the surroundings or enjoy resort activities. Overnight stay at Bharatpur."
    },
    {
      day: "Day 04",
      title: "Bharatpur – Ranthambore",
      content:
        "After breakfast, explore Bharatpur's sanctuary, gardens, and temples. Visit the famous Bharatpur Temple. Then, proceed to Ranthambore. Overnight stay at Ranthambore."
    },
    {
      day: "Day 05",
      title: "Ranthambore Wildlife Safari",
      content:
        "After an early breakfast, head for a thrilling jungle safari in Ranthambore National Park, a great place to spot tigers and other wildlife. Evening at leisure and shopping. Overnight stay at Ranthambore."
    },
    {
      day: "Day 06",
      title: "Ranthambore – Jaipur",
      content:
        "After breakfast, drive to Jaipur. Check in at the hotel and visit City Palace, Hawa Mahal, and Jantar Mantar. Enjoy evening shopping in Jaipur markets. Overnight stay at the hotel."
    },
    {
      day: "Day 07",
      title: "Jaipur Sightseeing & Departure",
      content:
        "After breakfast, explore Amber Fort, Nahargarh Fort, and City Palace complex including Chandra Mahal and Mubarak Mahal. In the evening, visit local bazaars. Later, transfer to Airport / Railway Station / Bus Stand for departure."
    }
  ],
  GoldenTriangle: [
    {
      day: "Day 01",
      title: "Delhi Arrival",
      content:
        "Pickup from Delhi Airport, Railway Station, or Bus Stand by our driver. Transfer to hotel for check-in. Visit Red Fort, Rashtrapati Bhawan, Jama Masjid, India Gate, Parliament House, Laxmi Narayan Temple, and Lotus Temple. Overnight stay at the hotel in Delhi.",
      meals: "Breakfast",
      entrances: [
        "Red Fort",
        "Rashtrapati Bhawan",
        "Jama Masjid",
        "India Gate",
        "Parliament House",
        "Laxmi Narayan Temple",
        "Lotus Temple"
      ]
    },
    {
      day: "Day 02",
      title: "Delhi – Agra",
      content:
        "Enjoy an early breakfast and drive to Agra, stopping en route at Sikandara, the mausoleum of Emperor Akbar. Check in at the hotel. In the afternoon, visit the iconic Taj Mahal – a symbol of eternal love. Also visit the marble inlay workshops. Overnight stay in Agra.",
      meals: "Breakfast",
      entrances: ["Taj Mahal"]
    },
    {
      day: "Day 03",
      title: "Agra – Fatehpur Sikri – Ranthambore",
      content:
        "After breakfast, drive to Ranthambore. En route, visit Fatehpur Sikri – the former Mughal capital, and see Buland Darwaza, the world’s largest gateway. On arrival in Ranthambore, check in to the resort and enjoy a jungle safari in the national park known for its wild tigers and the historic Ranthambore Fort. Overnight stay at the resort.",
      meals: "Breakfast",
      entrances: ["Fatehpur Sikri", "Buland Darwaza", "Ranthambore Fort"]
    },
    {
      day: "Day 04",
      title: "Ranthambore – Jaipur",
      content:
        "Begin with an early morning jungle excursion to spot tigers and other wildlife. After breakfast, drive to Jaipur. On arrival, visit City Palace, Hawa Mahal, and Jantar Mantar. Evening free for shopping and leisure. Overnight stay in Jaipur.",
      meals: "Breakfast",
      entrances: ["City Palace", "Hawa Mahal", "Jantar Mantar"]
    },
    {
      day: "Day 05",
      title: "Jaipur Sightseeing & Departure",
      content:
        "Explore Amber Fort, built of red sandstone and marble. Continue to visit the City Palace complex including Chandra Mahal and Mubarak Mahal, Hawa Mahal, and Nahargarh Fort. Enjoy last-minute shopping before drop-off at Airport / Railway Station / Bus Stand in Jaipur.",
      meals: "Breakfast",
      entrances: ["Amber Fort", "Chandra Mahal", "Mubarak Mahal", "Nahargarh Fort"]
    }
  ],
  MajesticRajasthan: [
    {
      day: "Day 01",
      title: "Jaipur Arrival & Sightseeing",
      content:
        "Enjoy your breakfast in the hotel and start your visit to the gorgeous Amber Fort Palace, a romantic Rajasthani fort known for its fusion of Mughal and Hindu architecture. Continue to explore Jaipur with City Palace and the astronomical marvel of Jantar Mantar. Later return to the hotel for overnight stay in Jaipur.",
      meals: "Breakfast",
      entrances: ["Amber Fort Palace", "City Palace", "Jantar Mantar", "Hawa Mahal"]
    },
    {
      day: "Day 02",
      title: "Jaipur Full-Day Sightseeing",
      content:
        "After breakfast, enjoy a full-day tour of the Pink City. Visit Jantar Mantar, Hawa Mahal, and explore the forts, palaces, monuments, and temples. Evening is free for shopping and leisure. Overnight stay at the hotel in Jaipur.",
      meals: "Breakfast",
      entrances: ["Jantar Mantar", "Hawa Mahal", "Sightseeing"]
    },
    {
      day: "Day 03",
      title: "Jaipur – Ajmer – Pushkar – Jodhpur",
      content:
        "After breakfast, drive to Jodhpur. Enroute visit the world-famous Ajmer Sharif Dargah, the Brahma Temple and Sarovar Lake in Pushkar. Arrive in Jodhpur by evening. Check-in at the hotel for overnight stay.",
      meals: "Breakfast",
      entrances: ["Dargah", "Brahma Temple", "Sarovar Lake"]
    },
    {
      day: "Day 04",
      title: "Jodhpur Sightseeing",
      content:
        "After breakfast, begin sightseeing of the 'Blue City' Jodhpur. Visit the majestic Mehrangarh Fort, Jaswant Thada, and the royal Umaid Bhawan Palace. Enjoy the view of the blue-painted houses. Overnight stay at the hotel in Jodhpur.",
      meals: "Breakfast",
      entrances: ["Mehrangarh Fort", "Jaswant Thada", "Umaid Bhawan Palace"]
    },
    {
      day: "Day 05",
      title: "Jodhpur – Ranakpur – Udaipur",
      content:
        "After breakfast, drive to Udaipur. Enroute, visit the famous Jain Temples of Ranakpur, known for their architecture and large number of pillars. Also visit a small Sun Temple managed by the royal family of Udaipur. Continue to Udaipur. Overnight stay at hotel.",
      meals: "Breakfast",
      entrances: ["Ranakpur Jain Temple", "Sun Temple"]
    },
    {
      day: "Day 06",
      title: "Udaipur Sightseeing",
      content:
        "After breakfast, explore Udaipur, the 'City of Lakes'. Visit City Palace, Lake Pichola, Saheliyon Ki Bari, Jag Mandir, and Jagdish Temple. Experience the royal charm and dine by the lakeside in the evening. Overnight stay in Udaipur.",
      meals: "Breakfast",
      entrances: ["City Palace", "Lake Pichola", "Saheliyon Ki Bari", "Jag Mandir", "Jagdish Temple"]
    },
    {
      day: "Day 07",
      title: "Udaipur Sightseeing & Departure",
      content:
        "After breakfast, visit Eklingji Temple, Bagore Ki Haveli, Pratap Smarak, Fateh Sagar Lake, Bhartiya Lok Kala Mandal, and Shilpgram. Enjoy a peaceful sunset boat ride on Lake Pichola to Jag Mandir. Later drop-off at Airport / Railway Station / Bus Stand.",
      meals: "Breakfast",
      entrances: ["Eklingji Temple", "Bagore Ki Haveli", "Pratap Smarak", "Fateh Sagar Lake", "Lok Kala Mandal", "Shilpgram", "Sunset Boat Ride"]
    }
  ],
  RajasthanAllWay: [
    {
      day: "Day 01",
      title: "Delhi Arrival",
      content:
        "Pickup from Delhi Airport, Railway Station, or Bus Stand by our driver and transfer to the hotel. Visit Red Fort, Rashtrapati Bhawan, Jama Masjid, India Gate, Parliament House, Laxmi Narayan Temple, and Lotus Temple. Overnight stay at the hotel in Delhi.",
      meals: "Breakfast",
      entrances: [
        "Red Fort",
        "Rashtrapati Bhawan",
        "Jama Masjid",
        "India Gate",
        "Parliament House",
        "Laxmi Narayan Temple",
        "Lotus Temple"
      ]
    },
    {
      day: "Day 02",
      title: "Delhi – Sariska",
      content:
        "After breakfast, continue Delhi sightseeing including Chandni Chowk and Qutub Minar. Later, drive to Sariska National Park. On arrival, check in at the hotel. Overnight stay in Sariska.",
      meals: "Breakfast",
      entrances: ["Chandni Chowk", "Qutub Minar", "Sariska National Park"]
    },
    {
      day: "Day 03",
      title: "Sariska – Jaipur via Ranthambore",
      content:
        "After breakfast, check out from the hotel and drive to Jaipur. On arrival, check in at the hotel and freshen up. Visit City Palace, Hawa Mahal, and Jantar Mantar. Enjoy shopping in the evening. Overnight stay at the hotel in Jaipur.",
      meals: "Breakfast",
      entrances: ["City Palace", "Hawa Mahal", "Jantar Mantar"]
    },
    {
      day: "Day 04",
      title: "Jaipur Full-Day Sightseeing",
      content:
        "After breakfast, drive to Amber Fort built of red sandstone and white marble. Later, visit Chandra Mahal, Mubarak Mahal, Hawa Mahal, and Nahargarh Fort. Evening is free for shopping and leisure. Overnight stay in Jaipur.",
      meals: "Breakfast",
      entrances: ["Amber Fort", "Chandra Mahal", "Mubarak Mahal", "Hawa Mahal", "Nahargarh Fort"]
    },
    {
      day: "Day 05",
      title: "Jaipur – Ajmer – Pushkar – Jodhpur",
      content:
        "After breakfast, depart for Jodhpur with enroute visits to Ajmer Sharif Dargah, Brahma Temple, and Sarovar Lake in Pushkar. Reach Jodhpur by evening. Check in and overnight stay at the hotel.",
      meals: "Breakfast",
      entrances: ["Ajmer Sharif Dargah", "Brahma Temple", "Sarovar Lake"]
    },
    {
      day: "Day 06",
      title: "Jodhpur Sightseeing",
      content:
        "After breakfast, visit the majestic Mehrangarh Fort, Jaswant Thada, and Umaid Bhawan Palace. Enjoy panoramic views of the blue houses in the city. Overnight stay at the hotel in Jodhpur.",
      meals: "Breakfast",
      entrances: ["Mehrangarh Fort", "Jaswant Thada", "Umaid Bhawan Palace"]
    },
    {
      day: "Day 07",
      title: "Jodhpur – Ranakpur – Udaipur",
      content:
        "After breakfast, drive to Udaipur. Enroute visit the famous marble Jain Temples of Ranakpur and the Sun Temple. Arrive in Udaipur and check in to the hotel. Overnight stay in Udaipur.",
      meals: "Breakfast",
      entrances: ["Ranakpur Jain Temple", "Sun Temple"]
    },
    {
      day: "Day 08",
      title: "Udaipur Sightseeing",
      content:
        "After breakfast, explore Udaipur including City Palace, Lake Pichola, Saheliyon ki Bari, Jag Mandir, and Jagdish Temple. Enjoy a royal dinner by the lakeside in the evening. Overnight stay in Udaipur.",
      meals: "Breakfast",
      entrances: ["City Palace", "Lake Pichola", "Saheliyon ki Bari", "Jag Mandir", "Jagdish Temple"]
    },
    {
      day: "Day 09",
      title: "Udaipur – Mount Abu",
      content:
        "After breakfast, visit Lake Palace, Bagore Ki Haveli, Pratap Smarak, and Fateh Sagar Lake. Then drive to Mount Abu. Upon arrival, visit Dilwara Temples, Guru Shikhar, and enjoy the sunset at Nakki Lake. Overnight stay at the hotel in Mount Abu.",
      meals: "Breakfast",
      entrances: ["Lake Palace", "Bagore Ki Haveli", "Pratap Smarak", "Fateh Sagar Lake", "Dilwara Temples", "Guru Shikhar", "Nakki Lake"]
    },
    {
      day: "Day 10",
      title: "Mount Abu – Departure",
      content:
        "Enjoy an early morning sunrise view. After breakfast, check out from the hotel and drive back to Udaipur. Later transfer to Airport / Railway Station / Bus Stand for your onward journey.",
      meals: "Breakfast",
      entrances: ["Sightseeing"]
    }
  ],
  RomanticRajasthan: [
    {
      day: "Day 01",
      title: "Udaipur Arrival",
      content:
        "On arrival at Udaipur, check into your hotel. Explore the city of lakes with attractions like the City Palace, Lake Pichola, Saheliyon ki Badi, and Jag Mandir. Enjoy a royal evening with fine dining by the lakeside.",
      meals: "Breakfast",
      entrances: [
        "Jagdish Temple",
        "Saheliyon ki Bari",
        "City Palace"
      ]
    },
    {
      day: "Day 02",
      title: "Udaipur Sightseeing",
      content:
        "After breakfast, visit Lake Palace, located in the middle of Lake Pichola. Explore Bagore Ki Haweli, Pratap Smarak, Fateh Sagar Lake, Bhartiya Lok Kala Mandal, and Shilp Gram. Enjoy a peaceful boat ride to Jag Mandir.",
      meals: "Breakfast",
      entrances: [
        "Lake Palace",
        "Bagore Ki Haweli",
        "Pratap Smarak",
        "Fateh Sagar Lake",
        "Bhartiya Lok Kala Mandal",
        "Shilp Gram"
      ]
    },
    {
      day: "Day 03",
      title: "Udaipur – Chittorgarh",
      content:
        "After breakfast, drive to Chittorgarh. Visit the famous Chittorgarh Fort, a symbol of Rajput pride, valor, and romance. Return to Udaipur for an overnight stay.",
      meals: "Breakfast",
      entrances: ["Chittorgarh Fort"]
    },
    {
      day: "Day 04",
      title: "Udaipur – Mount Abu",
      content:
        "Drive to Mount Abu in the morning. Upon arrival, visit Delwara Temple and Guru Shikhar. After lunch, enjoy the scenic beauty of Nakki Lake and the local market.",
      meals: "Breakfast",
      entrances: [
        "Delwara Temple",
        "Guru Shikhar",
        "Nakki Lake"
      ]
    },
    {
      day: "Day 05",
      title: "Mount Abu – Drive back Udaipur",
      content:
        "In the morning, check out from your hotel and drive back to Udaipur. Later, transfer to the railway station or airport for your onward journey.",
      meals: "Breakfast",
      entrances: [
        "City Palace",
        "Saheliyon Ki Bari",
        "Boat Ride",
        "Jag Mandir"
      ]
    }
  ],
  RoyalRajasthan: [
    {
      day: "Day 01",
      title: "Jaipur Arrival",
      content:
        "On arrival at Jaipur, check into your hotel, freshen up and set out to explore The Pink City. Visit the Amber Fort, built of red sandstone and white marble. Then visit the City Palace, which includes Chandra Mahal, Mubarak Mahal, and other architectural wonders. Evening is free for leisure and shopping at Jaipur.",
      meals: "Breakfast",
      entrances: [
        "Amber Fort",
        "City Palace",
        "Jantar Mantar",
        "Hawa Mahal"
      ]
    },
    {
      day: "Day 02",
      title: "Jaipur – Jodhpur",
      content:
        "After breakfast, depart for Jodhpur en route to visit the Dargah of Saint Moinnuidin Chishti in Ajmer, the Brahma Temple, and Sarovar Lake in Pushkar. Arrive in Jodhpur by evening and check-in at your hotel.",
      meals: "Breakfast",
      entrances: [
        "Dargah",
        "Brahma Temple",
        "Sarovar Lake"
      ]
    },
    {
      day: "Day 03",
      title: "Jodhpur Sightseeing",
      content:
        "After breakfast, visit the Mehrangarh Fort and Jaswant Thada for mesmerizing views of the city. Enjoy a relaxing evening before returning to your hotel for an overnight stay.",
      meals: "Breakfast",
      entrances: [
        "Mehrangarh Fort",
        "Jaswant Thada"
      ]
    },
    {
      day: "Day 04",
      title: "Jodhpur – Jaisalmer",
      content:
        "After breakfast, drive to Jaisalmer and explore the culture and customs of Rajasthan. In the afternoon, enjoy a visit to Sam Sand Dunes for a beautiful sunset and camel ride. Return to your hotel for an overnight stay.",
      meals: "Breakfast",
      entrances: [
        "Sam Sand Dunes"
      ]
    },
    {
      day: "Day 05",
      title: "Jaisalmer Sightseeing & Departure",
      content:
        "In the morning, visit Jaisalmer Fort, Museum, Jain Temple, Patwohki, and Kothari Haveli. After lunch, visit Kulcihera, Sam Sand Dunes again, and enjoy the DholaMaru magic. Later, transfer to the airport or railway station for your onward journey.",
      meals: "Breakfast",
      entrances: [
        "Jaisalmer Fort",
        "Museum",
        "Jain Temple",
        "Patwohki",
        "Kothari Haveli"
      ]
    }
  ],
  TempleHeritage: [
    {
      day: "Day 01",
      title: "Ajmer – Drive to Pushkar",
      content:
        "On arrival at Ajmer, drive to Pushkar, known as the 'king of pilgrim sites.' Visit the famous Brahma Temple and Pushkar Lake. After check-in at your hotel, relax and explore the spiritual ambiance of Pushkar.",
      meals: "Breakfast",
      entrances: [
        "Brahma Temple",
        "Pushkar Lake"
      ]
    },
    {
      day: "Day 02",
      title: "Pushkar – Jaipur",
      content:
        "Wake up to the sound of temple bells and enjoy a delicious breakfast before checking out. Proceed to visit the Shrine of Saint Moinnuidin Chishti at Dargah in Ajmer, then drive to Jaipur, the capital of Royal Rajasthan. In the evening, enjoy a cultural dance performance, puppet show, and traditional Rajasthani village life experience at Chokhi Dhani.",
      meals: "Breakfast",
      entrances: [
        "Dargah",
        "Cultural Dance",
        "Puppet Show"
      ]
    },
    {
      day: "Day 03",
      title: "Jaipur Sightseeing",
      content:
        "Start the day exploring the Pink City. Visit Amber Fort, a stunning structure made of red sandstone and white marble. Continue to the City Palace, including the Chandra Mahal, Mubarak Mahal, and other architectural marvels. Explore Hawa Mahal and Nahargarh Fort in the evening, with free time for shopping in Jaipur.",
      meals: "Breakfast",
      entrances: [
        "Amber Fort",
        "City Palace",
        "Chandra Mahal",
        "Mubarak Mahal",
        "Hawa Mahal",
        "Nahargarh Fort"
      ]
    },
    {
      day: "Day 04",
      title: "Jaipur – Departure",
      content:
        "After breakfast, explore the local bazaars of Jaipur for souvenirs. Later, transfer to the airport, railway station, or bus stand for your onward journey.",
      meals: "Breakfast",
      entrances: [
        "Local Market"
      ]
    }
  ],
  AndamanNicobar: [
    {
      day: "Day 01",
      title: "Port Blair: Arrival with visits to Cellular Jail and Corbyn's Cove Beach",
      content:
        "Arrive at Port Blair's Veer Savarkar Airport, where you will be greeted and transferred to your hotel. After check-in and relaxation, visit the Cellular Jail, where many freedom fighters were imprisoned. Then, head to Corbyn's Cove Beach for a peaceful walk or sunbathing. End the day with a light and sound show at the Cellular Jail.",
      meals: "Breakfast",
      entrances: [
        "Cellular Jail",
        "Corbyn's Cove Beach",
        "Light Sound Show"
      ]
    },
    {
      day: "Day 02",
      title: "Port Blair: Enjoy the beauty of Ross Island and North Bay Island",
      content:
        "After breakfast, take a two-island cruise to Ross Island and North Bay Island. Ross Island is a former British Headquarters and home to Smritika Museum. At North Bay Island, enjoy water activities like snorkeling and a glass-bottom boat ride to witness the beautiful coral colonies.",
      meals: "Breakfast",
      entrances: [
        "Ross Island",
        "North Bay Island",
        "Smritika Museum"
      ]
    },
    {
      day: "Day 03",
      title: "Havelock Island: Arrival and Radhanagar Beach visit",
      content:
        "After breakfast, check out and take a private cruise from Phoenix Bay Harbour to Havelock Island. Upon arrival, check-in at your resort. Enjoy a visit to Radhanagar Beach, known for its pristine white sand and crystal-clear waters. You can swim or simply relax while enjoying the stunning sunset.",
      meals: "Breakfast",
      entrances: [
        "Radhanagar Beach"
      ]
    },
    {
      day: "Day 04",
      title: "Port Blair: A day trip to Kalapathar Beach in Havelock and return to Port Blair",
      content:
        "Enjoy breakfast before heading to Kalapathar Beach, known for its striking greenish-blue water. After some beach time, return to Port Blair. After check-in at the hotel, enjoy an overnight stay.",
      meals: "Breakfast",
      entrances: [
        "Kalapathar Beach"
      ]
    },
    {
      day: "Day 05",
      title: "Port Blair: Departure back home",
      content:
        "After a hearty breakfast, check out from the hotel. You will be transferred to the Port Blair Airport for your onward journey, carrying with you beautiful memories of your Andaman vacation.",
      meals: "Breakfast",
      entrances: []
    }
  ],
  AndamanNicobarFamily: [
    {
      day: "Day 01",
      title: "Port Blair: City tour + Cellular Jail + Light and Sound Show",
      content:
        "Arrive at Port Blair and meet our representative. Start with a city tour including the Fisheries Museum, Anthropological Museum, Samudrika Museum, and Chatam Island. Later, visit the Cellular Jail, a historic prison used by the British to house freedom fighters. In the evening, enjoy the Light and Sound Show at Cellular Jail, which narrates the struggle for independence.",
      meals: "Breakfast",
      entrances: [
        "Fisheries Museum",
        "Anthropological Museum",
        "Samudrika Museum",
        "Chatam Island",
        "Cellular Jail",
        "Light Sound Show"
      ]
    },
    {
      day: "Day 02",
      title: "Havelock: Radhanagar Beach",
      content:
        "Transfer to Havelock Island by morning cruise/ferry. Visit Radhanagar Beach, one of Asia's best beaches, known for its pristine white sand and emerald waters. Enjoy swimming or relax on the beach. Explore your resort in the evening and unwind.",
      meals: "Breakfast",
      entrances: [
        "Radhanagar Beach"
      ]
    },
    {
      day: "Day 03",
      title: "Havelock: Elephant Beach + Snorkeling",
      content:
        "Take a boat ride to Elephant Beach, known for its white sandy coastline and vibrant coral reefs. Enjoy a free snorkeling session and explore the underwater world, including colorful marine life.",
      meals: "Breakfast",
      entrances: [
        "Elephant Beach",
        "Snorkeling"
      ]
    },
    {
      day: "Day 04",
      title: "Neil: Neil Island Tour",
      content:
        "After breakfast, transfer to Neil Island. Explore Sitapur Beach, Bharatpur Beach, and Laxmanpur Beach. Relax and enjoy the stunning beauty of these serene beaches. Overnight stay at Neil Island.",
      meals: "Breakfast",
      entrances: [
        "Sitapur Beach",
        "Bharatpur Beach",
        "Laxmanpur Beach"
      ]
    },
    {
      day: "Day 05",
      title: "Port Blair: Corbyn's Cove Beach",
      content:
        "After breakfast, transfer back to Port Blair by cruise/ferry. In the evening, visit Corbyn’s Cove Beach, a picturesque and tranquil beach perfect for relaxation.",
      meals: "Breakfast",
      entrances: [
        "Corbyn's Cove Beach"
      ]
    },
    {
      day: "Day 06",
      title: "Departure from Port Blair",
      content:
        "After a hearty breakfast, check out from the hotel. You will be transferred to the airport for your return journey, carrying wonderful memories of your Andaman family vacation.",
      meals: "Breakfast",
      entrances: []
    }
  ],
  Kerala: [
    {
      day: "Day 01",
      title: "Cochin: Arrival and drive to Munnar",
      content:
        "Upon arrival at Cochin Airport, meet our representative and drive to Munnar. Enroute, visit the beautiful Cheyyappara Water Falls. Check-in at your hotel and relax for the night.",
      meals: "Breakfast",
      entrances: ["Cheyyappara Water Falls"]
    },
    {
      day: "Day 02",
      title: "Munnar: Tea plantations, Tea Museum, and Eravikulam National Park",
      content:
        "After breakfast, enjoy a full-day city tour of Munnar. Visit the famous tea plantations, Tea Museum, and the Eravikulam National Park, home to the endangered Nilgiri Thar (Ibex). Also, explore Mattupetty Dam, Kundala Lake, and other scenic spots. Overnight stay at Munnar.",
      meals: "Breakfast",
      entrances: [
        "Tea Plantations",
        "Tea Museum",
        "Eravikulam National Park",
        "Mattupetty Dam",
        "Kundala Lake"
      ]
    },
    {
      day: "Day 03",
      title: "Munnar to Thekkady: Boat ride on Lake Periyar",
      content:
        "After breakfast, drive to Thekkady, home to one of the most fascinating wildlife reserves in the world. Upon arrival, check in at your hotel. In the evening, go for a boat ride on Lake Periyar (on your own arrangement) to witness wildlife and the herds of wild elephants. Overnight stay at Thekkady.",
      meals: "Breakfast",
      entrances: ["Lake Periyar"]
    },
    {
      day: "Day 04",
      title: "Thekkady to Alleppey: Houseboat cruise and sightseeing",
      content:
        "After breakfast, drive to Alleppey. Check-in at your hotel, then visit Coconut Lagoons and the Bird Sanctuary. Later, embark on a houseboat cruise through the breathtaking backwaters of Alleppey. Enjoy an overnight stay on the houseboat.",
      meals: "Breakfast",
      entrances: ["Coconut Lagoons", "Bird Sanctuary", "Houseboat Cruise"]
    },
    {
      day: "Day 05",
      title: "Alleppey to Cochin: Departure",
      content:
        "After breakfast, check out from the houseboat and transfer back to Cochin. Upon arrival, you will be transferred to Cochin airport to connect your flight for onward journey.",
      meals: "Breakfast",
      entrances: []
    }
  ],
  KerelaSpecial: [
    {
      day: "Day 01",
      title: "Guruvayur: Arrival and Darshan at Sri Krishna Temple",
      content:
        "Arrive at Trichur Railway Station or Cochin Airport, where our representative will welcome you and transfer you to your hotel in Guruvayur. After checking in and relaxing, proceed to visit the famous Sri Krishna Temple for darshan. Spend your overnight stay at the hotel.",
      meals: "Breakfast",
      entrances: ["Sri Krishna Temple"]
    },
    {
      day: "Day 02",
      title: "Guruvayur to Munnar: Arrival and Relax",
      content:
        "After breakfast, depart for Munnar (230 km / 4.5 hrs). Upon arrival, check in at your hotel and take some time to relax. Munnar is known for its picturesque tea estates and pleasant weather. Enjoy a peaceful evening and an overnight stay at the hotel.",
      meals: "Breakfast",
      entrances: []
    },
    {
      day: "Day 03",
      title: "Munnar: Tea Estates and Sightseeing",
      content:
        "After breakfast, embark on a scenic tour of Munnar, visiting the tea estates, the Mettupatty Dam, and enjoy a boat ride at Kundala Lake. Also, visit the Echo Point for panoramic views. Return to the hotel for an overnight stay.",
      meals: "Breakfast",
      entrances: ["Tea Estates", "Mettupatty Dam", "Kundala Lake", "Echo Point"]
    },
    {
      day: "Day 04",
      title: "Munnar to Thekkady: Wildlife and Boat Ride",
      content:
        "After breakfast, travel to Thekkady (120 km / 3.5 hrs). Explore the Periyar National Park, one of the most fascinating wildlife reserves in India. In the afternoon, take a boat cruise on Periyar Lake to spot wildlife, including elephants. Overnight stay at the hotel.",
      meals: "Breakfast",
      entrances: ["Periyar National Park", "Periyar Lake"]
    },
    {
      day: "Day 05",
      title: "Thekkady to Alleppey: Backwater Cruise",
      content:
        "After breakfast, drive to Alleppey (125 km / 3.5 hrs). Check in at your hotel and relax. Later, enjoy the famous backwaters ride through the serene waterways. Return to the hotel for your overnight stay.",
      meals: "Breakfast",
      entrances: ["Backwaters Cruise"]
    },
    {
      day: "Day 06",
      title: "Alleppey to Cochin: Sightseeing",
      content:
        "After breakfast, drive to Cochin (90 km / 1.5 hrs). In Cochin, visit the Dutch Palace, Jewish Synagogue, Chinese Fishing Nets, and Santa Cruz Basilica. In the evening, enjoy a boat ride by Sagar Rani. Overnight stay at the hotel.",
      meals: "Breakfast",
      entrances: ["Dutch Palace", "Jewish Synagogue", "Chinese Fishing Nets", "Santa Cruz Basilica", "Sagar Rani Boat Ride"]
    },
    {
      day: "Day 07",
      title: "Departure from Cochin",
      content:
        "After breakfast, transfer to Cochin Airport or Railway Station for your onward journey.",
      meals: "Breakfast",
      entrances: []
    }
  ],
  KeralaBackwaters: [
    {
      day: "Day 01",
      title: "Cochin: Arrival and Sightseeing",
      content:
        "Upon arrival at Cochin, our representatives will meet and transfer you to your hotel. After checking in and relaxing, visit the Dutch Palace Museum, Hill Palace Museum, Jewish Street, St. Francis Church, Jewish Synagogue, and Chinese Fishing Nets. Spend your overnight stay at the hotel in Cochin.",
      meals: "Breakfast",
      entrances: [
        "Dutch Palace Museum",
        "Hill Palace Museum",
        "Jewish Street",
        "St. Francis Church",
        "Jewish Synagogue",
        "Chinese Fishing Nets"
      ]
    },
    {
      day: "Day 02",
      title: "Cochin to Alleppey: Beach and Resort Stay",
      content:
        "After breakfast, check out from the hotel and drive to Alleppey (65 km / 2 hours). Upon arrival, check in at your resort. Take some time to relax and have lunch. In the evening, enjoy the peaceful atmosphere at Alleppey Beach. Overnight stay at the resort in Alleppey.",
      meals: "Breakfast",
      entrances: ["Alleppey Beach"]
    },
    {
      day: "Day 03",
      title: "Alleppey to Kumarakom: Houseboat Cruise",
      content:
        "After breakfast, check out from the resort and drive to Kumarakom (40 km / 1 hour). Upon arrival, check-in at a houseboat around 12:30 PM. Enjoy a full-day backwater cruise through Vembanad Lake. Experience the serene beauty of Kerala's backwaters while staying overnight on the houseboat.",
      meals: "Breakfast",
      entrances: ["Vembanad Lake"]
    },
    {
      day: "Day 04",
      title: "Kumarakom to Cochin: Departure",
      content:
        "After breakfast, check out from the houseboat by 9:30 AM and drive to Cochin (100 km / 3 hours). Upon arrival, transfer to Cochin Airport or Railway Station for your onward journey.",
      meals: "Breakfast",
      entrances: []
    }
  ],
  GoaTourPackage: [
    {
      day: "Day 01",
      title: "Goa: Arrival and Leisure Day",
      content:
        "Upon arrival at Goa Airport or Railway Station, our representative will greet you and transfer you to your hotel. After completing check-in formalities, you can spend the day leisurely. Explore the vibrant nightlife in Goa or relax at the sandy beaches. Return to the hotel for an overnight stay.",
      meals: "Breakfast",
      entrances: []
    },
    {
      day: "Day 02",
      title: "Goa: North Goa Tour",
      content:
        "Start the day with a dolphin sightseeing tour in the Arabian Sea. Watch dolphins playing in the waves. After breakfast, embark on a North Goa sightseeing tour, visiting Fort Aguada, Coco Beach, Calangute Annexe, Calangute Beach, Baga Beach, and Anjuna Beach. Return to the hotel for an overnight stay.",
      meals: "Breakfast",
      entrances: [
        "Fort Aguada",
        "Coco Beach",
        "Calangute Annexe",
        "Calangute Beach",
        "Baga Beach",
        "Anjuna Beach"
      ]
    },
    {
      day: "Day 03",
      title: "Goa: South Goa Exploration",
      content:
        "After breakfast, set out for a South Goa sightseeing tour. First, visit the Shri Shantadurga Temple at Kavlem and Shri Manguesh Temple at Priol. Continue to Old Goa to explore the Basilica of Bom Jesus and Se Cathedral. Visit Dona Paula Bay and Miramar Beach before returning to the hotel for an overnight stay.",
      meals: "Breakfast",
      entrances: [
        "Shri Shantadurga Temple",
        "Shri Manguesh Temple",
        "Basilica of Bom Jesus",
        "Se Cathedral",
        "Dona Paula Bay",
        "Miramar Beach"
      ]
    },
    {
      day: "Day 04",
      title: "Goa: Leisure Day",
      content:
        "Enjoy a full day at leisure in Goa. Relax at your hotel or go shopping for souvenirs. You can also savor Goan delicacies during your free time. Overnight stay at the hotel.",
      meals: "Breakfast",
      entrances: []
    },
    {
      day: "Day 05",
      title: "Goa: Departure",
      content:
        "After breakfast, check out from the hotel and proceed to Goa Airport or Railway Station for your onward journey, carrying sweet memories of your Goa trip.",
      meals: "Breakfast",
      entrances: []
    }
  ],
  GoaFamily: [
    {
      day: "Day 01",
      title: "Goa: Arrival and Leisure Day",
      content:
        "Upon arrival at Goa Airport or Railway Station, our representative will greet you and transfer you to your hotel. After completing check-in formalities, you have the entire day at leisure. You can explore local attractions or enjoy some local delicacies. Return to the hotel for an overnight stay.",
      meals: "Breakfast",
      entrances: []
    },
    {
      day: "Day 02",
      title: "Goa: North Goa Sightseeing Tour",
      content:
        "After a hearty breakfast, set out for a sightseeing tour in North Goa. Visit Aguada Fort for a panoramic view of the area, and then head to Calangute Beach, Baga Beach, and Anjuna Beach. Return to your hotel after a fun-filled day.",
      meals: "Breakfast",
      entrances: [
        "Aguada Fort",
        "Calangute Beach",
        "Baga Beach",
        "Anjuna Beach"
      ]
    },
    {
      day: "Day 03",
      title: "Goa: South Goa Sightseeing",
      content:
        "Start your day with a delicious breakfast and then head for a South Goa sightseeing tour. Visit Shri Shantadurga Temple and Shri Manguesh Temple, followed by Old Goa's Basilica of Bom Jesus and Se Cathedral. End the day with a visit to Dona Paula Bay and Miramar Beach.",
      meals: "Breakfast",
      entrances: [
        "Shri Shantadurga Temple",
        "Shri Manguesh Temple",
        "Basilica of Bom Jesus",
        "Se Cathedral",
        "Dona Paula Bay",
        "Miramar Beach"
      ]
    },
    {
      day: "Day 04",
      title: "Goa: Watersports & Leisure Day",
      content:
        "After breakfast, indulge in water sports at Candolim Beach, such as Jet Ski, Paragliding, Banana Boat Ride, and more. Afterward, enjoy leisure time at the beach or explore nearby shopping areas. Optional activities include crocodile sightseeing and birdwatching.",
      meals: "Breakfast",
      entrances: []
    },
    {
      day: "Day 05",
      title: "Goa: Island Tour",
      content:
        "Start your day with a filling breakfast, followed by a boat ride to Grand Island. Enjoy swimming, snorkeling, and marvel at the colorful marine life. After a delightful barbecue lunch, head back to the hotel.",
      meals: "Breakfast, Lunch (Barbecue)",
      entrances: ["Grand Island"]
    },
    {
      day: "Day 06",
      title: "Goa: Dudhsagar Waterfalls & Spice Plantation Tour",
      content:
        "After breakfast, embark on an excursion to the majestic Dudhsagar Waterfalls. Later, visit the aromatic spice plantations of Goa and enjoy a leisurely tour through nature's bounty.",
      meals: "Breakfast",
      entrances: ["Dudhsagar Waterfalls", "Spice Plantations"]
    },
    {
      day: "Day 07",
      title: "Goa: Departure",
      content:
        "After breakfast, check-out from the hotel and proceed to Goa Airport or Railway Station for your return journey, cherishing the memories of your wonderful family vacation.",
      meals: "Breakfast",
      entrances: []
    }
  ],
  LehLadakh: [
    {
      day: "Day 01",
      title: "Leh: Arrival and Leisure Day",
      content:
        "Arrive at Leh airport and transfer to the hotel. Take the day to acclimatize yourself to the high altitude of 11,135 feet. Enjoy a hot lunch at the hotel, and in the evening, visit Leh Market, Leh Palace, and Shanti Stupa for some sightseeing.",
      meals: "Lunch",
      entrances: ["Leh Market", "Leh Palace", "Shanti Stupa"]
    },
    {
      day: "Day 02",
      title: "Leh: Shey, Thiksey, Stok, Gurudwara, Sangam, and Magnetic Hill",
      content:
        "After breakfast, visit the Thiksey Monastery and Stok Palace Museum. Enjoy hot lunch and continue to visit Sindhu Ghat, Pathar Sahib Gurudwara, Hall of Fame, Magnetic Hill, and Sangam (Confluence of Zanskar & Indus River). Return to Leh in the evening.",
      meals: "Breakfast, Lunch",
      entrances: [
        "Thiksey Monastery",
        "Stok Palace Museum",
        "Sindhu Ghat",
        "Pathar Sahib Gurudwara",
        "Hall of Fame",
        "Magnetic Hill",
        "Sangam"
      ]
    },
    {
      day: "Day 03",
      title: "Leh: Pangong Lake Day Trip",
      content:
        "Start early for a day trip to Pangong Lake, via ChangLa Pass (17,350 ft.). Enjoy the beauty of the lake and its different hues. After spending time at the lake, return to Leh by the same route in the evening.",
      meals: "Breakfast, Lunch",
      entrances: ["Pangong Lake"]
    },
    {
      day: "Day 04",
      title: "Leh: Departure",
      content:
        "After breakfast, check out from the hotel and transfer to Leh airport for your onward journey, carrying wonderful memories of your Leh Ladakh trip.",
      meals: "Breakfast",
      entrances: []
    }
  ],
  LehLadakhShades: [
    {
      day: "Day 01",
      title: "Leh: Arrival and Leisure Day",
      content:
        "Arrive at Leh Airport and transfer to the hotel for check-in. The day is free for leisure and acclimatization to the high altitude of 11,135 feet. Explore the Leh town and get familiar with the climate. Overnight stay at the hotel in Leh.",
      meals: "Breakfast",
      entrances: []
    },
    {
      day: "Day 02",
      title: "Leh: Hall of Fame, Gurudwara Pathar Sahib, Magnetic Hill, and Sangam",
      content:
        "After breakfast, leave for a half-day excursion to the Hall of Fame, Gurudwara Pathar Sahib, Magnetic Hill, and Sangam View, where the Indus and Zanskar rivers meet. In the evening, enjoy the sunset at Shanti Stupa. Return to the hotel for the night.",
      meals: "Breakfast, Dinner",
      entrances: [
        "Hall of Fame",
        "Gurudwara Pathar Sahib",
        "Magnetic Hill",
        "Sangam View"
      ]
    },
    {
      day: "Day 03",
      title: "Leh: Pangong Lake",
      content:
        "After breakfast, check out and drive to Pangong Lake. Cross the Changla Pass (17,500 ft) and travel through Durbuk and Tangtse villages in the Changthang region of Ladakh. Enjoy the breathtaking views of Pangong Lake, known for changing its color multiple times a day. Stay overnight at the camp near Pangong Lake.",
      meals: "Breakfast, Dinner",
      entrances: ["Pangong Lake"]
    },
    {
      day: "Day 04",
      title: "Leh: Return from Pangong Lake",
      content:
        "After breakfast, check out from the camp and drive back to Leh. Enroute, visit Hemis, Shey, and Thiksey monasteries. Enjoy the evening free for leisure and personal activities. Stay overnight at the hotel in Leh.",
      meals: "Breakfast, Dinner",
      entrances: [
        "Hemis Monastery",
        "Shey Monastery",
        "Thiksey Monastery"
      ]
    },
    {
      day: "Day 05",
      title: "Leh: Khardung La Pass and Nubra Valley",
      content:
        "After breakfast, drive to Nubra Valley, crossing the Khardung La Pass (18,380 ft), the highest motorable road in the world. Nubra Valley, also known as the Valley of Flowers, lies between the Karakoram and Ladakh ranges. On arrival at Hunder, check in at the hotel or camp. Visit Diskit Village and enjoy a camel ride on the sand dunes. Dinner and overnight stay at the camp.",
      meals: "Breakfast, Dinner",
      entrances: ["Diskit Village"]
    },
    {
      day: "Day 06",
      title: "Leh: Return from Nubra Valley",
      content:
        "After breakfast, drive back to Leh via Khardung La Pass. Upon arrival, check in at the hotel. In the evening, explore the Leh market for shopping. Stay overnight at the hotel.",
      meals: "Breakfast, Dinner",
      entrances: []
    },
    {
      day: "Day 07",
      title: "Leh: Departure",
      content:
        "After breakfast, check out from the hotel and transfer to Leh Airport for your return journey, concluding your memorable tour of the land of dragons.",
      meals: "Breakfast",
      entrances: []
    }
  ],
  Sikkim: [
    {
      day: "Day 01",
      title: "Arrival at Gangtok",
      content:
        "Welcome to the beautiful city of Gangtok. A representative will receive you at the Bagdogra Airport and escort you to your hotel. Check-in and relax. Spend the rest of the day exploring the lively streets and soaking in the serene ambiance of the city. Overnight stay at the hotel in Gangtok.",
      meals: "Dinner",
      entrances: []
    },
    {
      day: "Day 02",
      title: "Full-day Gangtok Excursion",
      content:
        "After breakfast, head out for a day trip to the famous Tsomgo Lake and Baba Harbhajan Mandir. Enjoy the scenic lake surrounded by snow-covered peaks and watch Brahmin ducks swim peacefully. Later, visit the Baba Mandir to seek blessings. Return to the hotel for overnight stay.",
      meals: "Breakfast, Dinner",
      entrances: ["Tsomgo Lake", "Baba Harbhajan Mandir"]
    },
    {
      day: "Day 03",
      title: "Travel to Lachung via Scenic Spots",
      content:
        "After breakfast, proceed for a road trip to Lachung. En route, enjoy views from Singhik Viewpoint, the lush Chumthang Valley, sparkling Vima Falls, and Twin Falls. Upon arrival in Lachung, check-in at the hotel and explore the charming village and the historic Lachung Monastery. Overnight stay in Lachung.",
      meals: "Breakfast, Dinner",
      entrances: [
        "Singhik Viewpoint",
        "Chumthang Valley",
        "Vima Falls",
        "Twin Falls",
        "Lachung Monastery"
      ]
    },
    {
      day: "Day 04",
      title: "Lachung to Gangtok via Yumthang Valley",
      content:
        "After breakfast, embark on an excursion to Yumthang Valley, known for its colorful rhododendron flowers and natural beauty. Also visit the Yumthang Hot Spring, a natural jacuzzi experience. Return to Gangtok by evening and check-in at the hotel. Overnight stay in Gangtok.",
      meals: "Breakfast, Dinner",
      entrances: ["Yumthang Valley", "Yumthang Hot Spring"]
    },
    {
      day: "Day 05",
      title: "Departure from Gangtok",
      content:
        "Wake up to your last day in Sikkim. After breakfast, check-out from the hotel and proceed to Bagdogra Airport for your onward journey with wonderful memories of Gangtok and Lachung.",
      meals: "Breakfast",
      entrances: []
    }
  ],
  GangtokSikkim: [
    {
      day: "Day 01",
      title: "Arrival in Gangtok",
      content:
        "On your arrival at NJP Railway Station / Tenzing Norgay Bus Stand / Bagdogra Airport, meet our representative who transfers you to Gangtok. After check-in at the hotel, relax and enjoy the beautiful town. In the evening, stroll around MG Road or explore local markets.",
      meals: "Dinner",
      entrances: ["MG Road", "Local Market"]
    },
    {
      day: "Day 02",
      title: "Excursion to Tsomgo Lake and Baba Mandir",
      content:
        "After breakfast, head out to visit Tsomgo Lake and Baba Harbhajan Mandir. Tsomgo Lake is a glacial lake at 3780 meters surrounded by snow-capped peaks and alpine flora. The Baba Mandir, dedicated to soldier Baba Harbhajan, holds spiritual significance. Return to Gangtok in the evening and enjoy free time at MG Road.",
      meals: "Breakfast, Dinner",
      entrances: ["Tsomgo Lake", "Baba Harbhajan Mandir", "MG Road"]
    },
    {
      day: "Day 03",
      title: "Gangtok to Lachen",
      content:
        "After breakfast, drive to Lachen with a stopover at Chungthang for lunch. Enjoy scenic views of the hills and valleys along the route. Lachen, situated at 2750 meters, is a gateway to the Green Lake Trek and other attractions. Check-in and relax at the hotel.",
      meals: "Breakfast, Lunch, Dinner",
      entrances: ["Chungthang", "Lachen Village"]
    },
    {
      day: "Day 04",
      title: "Lachen to Gurudongmar Lake to Lachung",
      content:
        "After breakfast, proceed to visit the sacred Gurudongmar Lake, one of the highest lakes in the world at 17,100 feet. After soaking in its beauty, continue your journey to Lachung, a picturesque village surrounded by rhododendrons and mountains. In the evening, visit the famous Lachung Monastery.",
      meals: "Breakfast, Lunch, Dinner",
      entrances: ["Gurudongmar Lake", "Lachung Monastery"]
    },
    {
      day: "Day 05",
      title: "Excursion to Yumthang Valley",
      content:
        "After breakfast, visit the breathtaking Yumthang Valley. En route, stop at a natural hot spring known for its medicinal properties. Enjoy the valley's alpine meadows, rhododendron blooms, and scenic landscapes. In the evening, explore Lachung village before returning to your hotel.",
      meals: "Breakfast, Dinner",
      entrances: ["Yumthang Valley", "Hot Spring"]
    },
    {
      day: "Day 06",
      title: "Lachung to Gangtok",
      content:
        "Post breakfast, drive back to Gangtok. Enjoy spectacular views of the Eastern Himalayas and the Kanchenjunga range en route. After arrival, check in at the hotel and spend the evening at leisure shopping or strolling around MG Road.",
      meals: "Breakfast, Dinner",
      entrances: ["Kanchenjunga View", "MG Road"]
    },
    {
      day: "Day 07",
      title: "Departure from Gangtok",
      content:
        "After breakfast, check out from the hotel and get transferred to NJP Railway Station / Tenzing Norgay Bus Stand / Bagdogra Airport for your onward journey with wonderful memories of Sikkim.",
      meals: "Breakfast",
      entrances: []
    }
  ],
  Kashmir: [
    {
      day: "Day 01",
      title: "Arrive Srinagar",
      content:
        "On arrival in Srinagar, our representative will meet and greet you at the airport. Transfer to the deluxe houseboat in Srinagar. Evening free to relax and enjoy the scenic view of the mountain ranges near Dal Lake.",
      meals: "Dinner",
      entrances: ["Dal Lake", "Mountain Views"]
    },
    {
      day: "Day 02",
      title: "Srinagar Local Sightseeing",
      content:
        "After breakfast, proceed for a Shikara ride on Dal Lake. Explore backwaters, canals, floating gardens, and markets. After lunch at the hotel, visit Mughal Gardens – Cheshma Shahi, Nishat Garden, and Shalimar Bagh. Then visit Shankaracharya Temple for panoramic views of Srinagar. Also visit the handloom center famous for Pashmina and Shahtoosh shawls.",
      meals: "Breakfast, Lunch, Dinner",
      entrances: ["Dal Lake", "Cheshma Shahi", "Nishat Garden", "Shalimar Bagh", "Shankaracharya Temple", "Handloom Center"]
    },
    {
      day: "Day 03",
      title: "Srinagar – Sonamarg – Srinagar",
      content:
        "After breakfast, proceed towards Sonamarg, a scenic hill station surrounded by high mountains, forests, and lakes. Explore the valleys including Aru Valley, Kolhai Glacier, Chandanwari, and others. Return back to Srinagar for dinner.",
      meals: "Breakfast, Lunch, Dinner",
      entrances: ["Sonamarg", "Aru Valley", "Kolhai Glacier", "Chandanwari", "Sheshnag", "Baisaran", "Mamleshwar Temple"]
    },
    {
      day: "Day 04",
      title: "Srinagar – Gulmarg – Srinagar",
      content:
        "After breakfast, go on an excursion to Gulmarg. Enjoy the scenic beauty of snow-capped mountains. Activities include skiing, cable car ride, and visiting the highest golf course. Return to Srinagar in the evening.",
      meals: "Breakfast, Dinner",
      entrances: ["Gulmarg", "Cable Car", "Golf Course"]
    },
    {
      day: "Day 05",
      title: "Departure from Srinagar",
      content:
        "After breakfast, enjoy some local sightseeing in Srinagar city. Later, proceed to the airport to board your flight for your onward journey.",
      meals: "Breakfast",
      entrances: ["Srinagar City"]
    }
  ],
  KashmirSecond: [
    {
      day: "Day 01",
      title: "Arrive Srinagar",
      content:
        "On arrival in Srinagar, our representative will greet you and transfer you to a deluxe houseboat. Spend the evening relaxing and enjoying scenic views of the high mountains and valleys.",
      meals: "Dinner",
      entrances: ["Deluxe Houseboat", "Dal Lake Views", "Mountain Landscapes"]
    },
    {
      day: "Day 02",
      title: "Srinagar Local Sightseeing",
      content:
        "After breakfast, enjoy a Shikara boat ride on Dal Lake. Explore floating gardens, canals, and local handicraft vendors. Later visit the famous Mughal Gardens: Chashma Shahi, Nishat Bagh, and Shalimar Bagh. End the day with a visit to Shankaracharya Temple offering panoramic city views.",
      meals: "Breakfast, Dinner",
      entrances: ["Dal Lake", "Floating Gardens", "Chashma Shahi", "Nishat Bagh", "Shalimar Bagh", "Shankaracharya Temple"]
    },
    {
      day: "Day 03",
      title: "Srinagar – Sonamarg – Srinagar",
      content:
        "After breakfast, enjoy a full-day excursion to Sonamarg – a beautiful hill station with dense forests and towering mountains. Return to Srinagar in the evening for dinner and overnight stay.",
      meals: "Breakfast, Dinner",
      entrances: ["Sonamarg", "Sindh Valley", "Thajiwas Glacier"]
    },
    {
      day: "Day 04",
      title: "Srinagar – Pahalgam",
      content:
        "After breakfast, drive to Pahalgam, a renowned hill resort surrounded by forests and lakes. After lunch at the hotel, relax or explore nearby areas.",
      meals: "Breakfast, Lunch, Dinner",
      entrances: ["Pahalgam", "Lidder River", "Valleys"]
    },
    {
      day: "Day 05",
      title: "Pahalgam Sightseeing",
      content:
        "After breakfast, visit Aru Valley or Chandanwari (base of Amarnath Yatra) at your own cost. Return to hotel for lunch. Evening is free for leisure and personal exploration.",
      meals: "Breakfast, Lunch, Dinner",
      entrances: ["Aru Valley", "Chandanwari", "Betaab Valley (optional)"]
    },
    {
      day: "Day 06",
      title: "Pahalgam – Gulmarg",
      content:
        "Post breakfast, drive to Gulmarg, a snow-covered paradise popular for winter sports. Enjoy scenic views and optional activities like skiing and cable car ride. Evening at leisure.",
      meals: "Breakfast, Dinner",
      entrances: ["Gulmarg", "Snowy Peaks", "Skiing Slopes"]
    },
    {
      day: "Day 07",
      title: "Gulmarg Activities",
      content:
        "After breakfast, enjoy a horse ride to Khilanmarg – a beautiful meadow with panoramic views. Later enjoy the world’s highest cable car (Gondola) ride from Kongdoori. Evening return to hotel.",
      meals: "Breakfast, Dinner",
      entrances: ["Khilanmarg", "Gondola Cable Car", "Kongdoori"]
    },
    {
      day: "Day 08",
      title: "Gulmarg – Srinagar Airport",
      content:
        "After breakfast, enjoy leisure time. Later, drive to Srinagar Airport (60 kms, 2 hrs) for your onward flight.",
      meals: "Breakfast",
      entrances: ["Gulmarg", "Scenic Route to Airport"]
    }
  ]
};
export default itineraries;